import { useState } from 'react';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenu, CardMenuHeader } from '../../cardMenu/components/CardMenu';
import { PlaylistAssignmentsSearchProvider } from './PlaylistAssignmentsSearch';
import { UnAssignPlaylist, UnassignPlaylistHeader } from './UnAssignPlaylist';
import { usePlaylistAssignmentsPortals } from '../playlistAssignmentsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const RowSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "CardMenuUnassignPlaylistOption__RowSpinner",
  componentId: "n0bh22-0"
})(["position:absolute;right:10px;"]);
const useIsLoadingFirstPlaylistAssignmentsPage = (playlistId, isOpen) => {
  const {
    playlistAssignmentsPortalsLoading
  } = usePlaylistAssignmentsPortals({
    playlistId,
    skip: !isOpen
  });
  return playlistAssignmentsPortalsLoading;
};
export const CardMenuUnassignPlaylistOption = ({
  playlistId,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOnOpenChange = e => setIsOpen(e.target.value);
  const handleUnassignClick = () => setIsOpen(true);
  const isLoadingFirstPlaylistAssignmentsPage = useIsLoadingFirstPlaylistAssignmentsPage(playlistId, isOpen);
  const handleOnUnassigned = (portalId, assignmentId) => {
    setIsOpen(false);
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  return /*#__PURE__*/_jsx(PlaylistAssignmentsSearchProvider, {
    children: /*#__PURE__*/_jsx(CardMenu, {
      content: {
        header: /*#__PURE__*/_jsx(CardMenuHeader, {
          children: /*#__PURE__*/_jsx(UnassignPlaylistHeader, {})
        }),
        body: /*#__PURE__*/_jsx(UnAssignPlaylist, {
          onAssignmentClick: onAssignmentClick,
          onPortalClick: onPortalClick,
          onUnassigned: handleOnUnassigned,
          playlistId: playlistId
        })
      },
      onOpenChange: handleOnOpenChange,
      open: isOpen && !isLoadingFirstPlaylistAssignmentsPage,
      placement: "right bottom",
      children: /*#__PURE__*/_jsx(UISideNavItem, {
        "data-test-id": "unassign-playlist-button",
        iconRight: isLoadingFirstPlaylistAssignmentsPage ? /*#__PURE__*/_jsx(RowSpinner, {
          size: "extra-small"
        }) : 'right',
        onClick: handleUnassignClick,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.unassignPlaylist"
        })
      })
    })
  });
};
export default CardMenuUnassignPlaylistOption;